import { DashboardState } from '@modules/dashboard/store/types';
import { v4 as uuidv4 } from 'uuid';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { DRAFT_DASHBOARD } from '../constants';

export const dashboardInitialState: DashboardState = {
  dashboard: DRAFT_DASHBOARD,
  query: {
    duration: undefined,
    whereClause: EmptyWhereClause,
  },
  visual: {
    queryBuilderKey: uuidv4(),
    shouldShowQueryBuilder: false,
    loadingAnalysesByID: {},
    dragItemData: null,
    dropTargetData: null,
    isPolling: false,
    isUpdateDashboardInProgress: false,
    cellMinimumHeightsByRowID: {},
    isReadOnly: false,
    context: 'Default',
    dashboardTypeDisplayName: 'Dashboard',
  },
  metadata: {
    layout: {
      rows: [],
    },
    analysesMetadata: [],
  },
};
